module.exports = __webpack_public_path__ + "static/media/icon_locate.f39a901a.svg";